import { Injectable } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { map, distinctUntilChanged, filter } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { Luoghi, IComune, INazione } from './luoghi';

// Questo si potrebbe rendere più performante con un 
// po' di inlining manuale... Ma renderebbe il codice
// ancora più criptico...
const traduzioneVocali = new Map<string, string>([
	[ 'A', 'A' ],
	[ 'À', 'A' ],
	[ 'Á', 'A' ],
	[ 'Ä', 'A' ],

	[ 'E', 'E' ],
	[ 'È', 'E' ],
	[ 'É', 'E' ],
	[ 'Ë', 'E' ],

	[ 'I', 'I' ],
	[ 'Ì', 'I' ],
	[ 'Í', 'I' ],
	[ 'Ï', 'I' ],

	[ 'O', 'O' ],
	[ 'Ò', 'O' ],
	[ 'Ó', 'O' ],
	[ 'Ö', 'O' ],

	[ 'U', 'U' ],
	[ 'Ù', 'U' ],
	[ 'Ú', 'U' ],
	[ 'Ü', 'U' ]
]);

function IsWhiteSpace(value: string) {
	return /\s/.test(value);
}

function ExtractChars(input: string, isNome: boolean): string
{
	let vocali = '', consonanti = '';

	for(const ch of [...input.toUpperCase()])
	{
		if (!IsWhiteSpace(ch) && ch != '\'') {
			const vocale = traduzioneVocali.get(ch);
			if (vocale) {
				vocali += vocale;
			} else {
				consonanti += ch;
			}
		}
	}

	if (consonanti.length >= 3) {
		if(isNome && consonanti.length > 3) {
			return consonanti[0] + consonanti[2] + consonanti[3];
		} else {
			return consonanti.substr(0, 3);
		}
	} else {
		// Left padding prima con le vocali, poi con le 'X'
		return (consonanti + vocali + 'XXX').substr(0, 3);
	}
}


function GetCharData(data: NgbDateStruct, sesso: string): string
{

	let retVal = data.year.toString().substr(2, 2);

	switch (data.month)
	{
		case 1:
			retVal += 'A';
			break;
		case 2:
			retVal += 'B';
			break;
		case 3:
			retVal += 'C';
			break;
		case 4:
			retVal += 'D';
			break;
		case 5:
			retVal += 'E';
			break;
		case 6:
			retVal += 'H';
			break;
		case 7:
			retVal += 'L';
			break;
		case 8:
			retVal += 'M';
			break;
		case 9:
			retVal += 'P';
			break;
		case 10:
			retVal += 'R';
			break;
		case 11:
			retVal += 'S';
			break;
		case 12:
			retVal += 'T';
			break;
	}

	if (sesso === 'M')
	{
		// FIXME non mi piace
		let strTemp = data.day.toString();
		if (strTemp.length <= 1)
		{
			retVal += "0" + strTemp;
		} else {
			retVal += strTemp;
		}
	}
	else {
		retVal += (data.day + 40).toString();
	}
	
	return retVal;
}

function GetCharComune(
	comuni: Map<string, string>, 
	nazioni: Map<string, string>, 
	nazione: string, 
	comune: string
): string
{
	if (!nazione || nazione == "ITALIA") {
		const codcatasto = comuni.get(comune);
		if (codcatasto) {
			return codcatasto;
		}
	} else {
		var codcatasto = nazioni.get(nazione);

		if (codcatasto != null) {
			return codcatasto;
		}
	};
}

const arrPesi = [ 
	1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 1, 0, 5, 7, 9, 13, 15, 17, 19, 
	21, 2, 4, 18, 20, 11, 3, 6, 8, 12, 14, 16, 10, 22, 25, 24, 23 
];

function CodFiscControl(strVal: string): string
{
	const A = 'A'.charCodeAt(0);
	const Z = '0'.charCodeAt(0);
	let pesi = 0;

	strVal = strVal.toUpperCase();

	for (let i = 0; i < 15; ++i) {
		if (((i + 1) % 2) == 0) {
			if (
				strVal[i] >= '0' && 
				strVal[i] <= '9'
			) {
				pesi += strVal.charCodeAt(i) - Z;
			} else if (
				strVal[i] >= 'A' && 
				strVal[i] <= 'Z'
			) {
				pesi += strVal.charCodeAt(i) - A;
			}
		} else {
			if (
				strVal[i] >= '0' && 
				strVal[i] <= '9'
			) {				
				pesi += arrPesi[strVal.charCodeAt(i) - Z];
			} else if (
				strVal[i] >= 'A' && 
				strVal[i] <= 'Z'
			) {
				pesi += arrPesi[strVal.charCodeAt(i) - A + 10];
			}
		}
	}
	return String.fromCharCode(A + (pesi % 26));
}

@Injectable()
export class CodiceFiscale {
	private comuni: Observable<Map<string, string>>;
	private nazioni: Observable<Map<string, string>>;

	constructor(
		luoghi$: Luoghi
	) {
		this.comuni = luoghi$.comuni.pipe(
			map(c => c.reduce(
				(out, c) => out.set(c.citta.toLocaleUpperCase(), c.codcatasto), 
				new Map<string, string>()
			))
		);

		this.nazioni = luoghi$.nazioni.pipe(
			map(c => c.reduce(
				(out, c) => out.set(c.nome.toLocaleUpperCase(), c.codcatasto),
				new Map<string, string>()
			))
		);
	}

	compute(nome: string,
		cognome: string,
		genere: string,
		dataNascita: NgbDateStruct,
		luogoNascita: string,
		nazione: string
	): Observable<string> 
	{
		return Observable.combineLatest(
			this.comuni, 
			this.nazioni
		).pipe(
			map(([comuni, nazioni]) => 
				ExtractChars(cognome, false) +
				ExtractChars(nome, true) +
				GetCharData(dataNascita, genere) +
				GetCharComune(
					comuni, 
					nazioni, 
					nazione, 
					luogoNascita
				) || ''
			),
			filter(cf => cf.length === 15),
			map(cf => cf + CodFiscControl(cf))
		);
	}

	// controlla che l'ultimo carattere del codice fiscale sia corretto oltre alla sua lunghezza di 16
	static check(cf: string): boolean
	{
		return ((cf.length == 16) && (CodFiscControl(cf) == cf[15]));
	}
}


// WEBPACK FOOTER //
// ./src/app/model/codice_fiscale.ts